export const validateUser = (value) => {
  let regexUsername = /^[a-zA-Z0-9_.]+$/;
  return regexUsername.test(value);
}

export const validateEmail = (value) => {
  let regexEmail = /^(\w+[/./-]?){1,}@[a-z]+[/.]\w{2,}$/;
  return regexEmail.test(value);
}

export const validateWithdrawPay4Fun = (form) => {
  if(form.monto2.trim()===""|| parseFloat(form.monto2.replaceAll(".", "").replace(",", ".")).toFixed(2) <= 0) return "Ingrese el monto a retirar";
  if(form.nombre==='') return 'el campo "NOMBRE COMPLETO" no puede estar vacio'
  if(form.cedula==='') return 'el campo "CPF" no puede estar vacio'
  if(form.email==='') return 'el campo "EMAIL" no puede estar vacio'
  if(form.pixKeyType==='') return 'el campo "PIX" no puede estar vacio'
  if(form.pixKeyType==='Telefone') {
    if(form.codigoArea==='') return 'El campo "CÓDIGO DE ÁREA" no puede estar vacio'
    if(form.telefono==='') return 'El campo "TELÉFONO" no puede estar vacio'
  }
  if(form.pixKeyType==='DadosBancarios') {
    if(form.nombreBanco==='') return 'El campo "NOMBRE DEL BANCO" no puede estar vacio'
    if(form.numeroCuenta==='') return 'El campo "NÚMERO CUENTA" no puede estar vacio'
    if(form.tipoCuenta==='') return 'El campo "TIPO DE CUENTA" no puede estar vacio'
    if(form.sucursalBanco==='') return 'El campo "SUCURSAL BANCO" no puede estar vacio'
  }
  return "ok"
}